import './LeJourJ.css';

const PROGRAMME = [
  { heure: '15h30', titre: 'Arrivée des invités', texte: 'Prends quelques instants pour découvrir le domaine en attendant l\'arrivée des stars du jour 😎' },
  { heure: '16h00', titre: 'Cérémonie', texte: 'Le grand moment\u00A0! Quelques mots, beaucoup d\'émotion et un grand oui 💍' },
  { heure: '17h00', titre: 'Vin d\'honneur et apéritif', texte: 'Time to trinque\u00A0! Au programme\u00A0: vin, bière et petits fours\u00A0!' },
  { heure: '18h30', titre: 'Souper', texte: 'Parce que bien manger, c\'est le début du bonheur\u00A0!' },
  { heure: '20h00', titre: 'Fiesta', texte: 'La piste de danse est déclarée ouverte\u00A0! Dansons jusqu\'au bout de la nuit .' },
  { heure: '04h00', titre: 'Fin de la fête', texte: 'Profite d\'une dernière danse avant de rentrer te remettre de ces belles émotions' },

];

function LeJourJ() {
  return (
    <div className="section container">
      <h1 className="section-title">Le jour J</h1>
      <p className="section-subtitle">
        Toutes les informations pratiques pour notre grand jour.
      </p>

      <div className="programme">
        {PROGRAMME.map((etape) => (
          <div className="programme-item card" key={etape.heure}>
            <span className="programme-heure">{etape.heure}</span>
            <div>
              <h3>{etape.titre}</h3>
              <p>{etape.texte}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="lieu card">
        <h2>Le lieu</h2>
        <div className="lieu-photos">
          <img src="/images/buritaz-1.jpg" alt="Domaine de la Buritaz - façade" />
          <img src="/images/buritaz-2.jpg" alt="Domaine de la Buritaz - vue aérienne des terrasses" />
        </div>
        <div className="map-wrapper">
          <iframe
            title="Domaine de la Buritaz"
            src="https://www.google.com/maps?q=Domaine+de+la+Buritaz,+Chemin+de+la+Buritaz+1,+1070+Puidoux,+Suisse&output=embed"
            width="100%"
            height="360"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>

      <div className="dresscode card">
        <h2>Tenue</h2>
        <div className="dresscode-item start">
          <span className="dresscode-check" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M4 12.5L9.5 18L20 6.5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
          <div>
            <p>
              Tenue habillée, couleurs vives et motifs floraux, sens-toi beau·belle&nbsp;! Pour celles et ceux qui le souhaitent, voici la palette de couleurs
            </p>
            <div className="palette-swatches">
              <span className="palette-swatch" title="Orange vif" style={{ background: 'var(--color-primary)' }} />
              <span className="palette-swatch" title="Jaune moutarde" style={{ background: 'var(--color-secondary)' }} />
              <span className="palette-swatch" title="Rose poudré" style={{ background: 'var(--color-accent)' }} />
              <span className="palette-swatch" title="Vert olive" style={{ background: 'var(--color-accent-2)' }} />
            </div>
          </div>
        </div>
        <div className="dresscode-item">
          <span className="dresscode-check" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M4 12.5L9.5 18L20 6.5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
          <p>
            Le blanc et toutes ses déclinaisons sont réservés à la mariée&nbsp;!
          </p>
        </div>
      </div>
    </div>
  );
}

export default LeJourJ;
